import { render, staticRenderFns } from "./MarketingMaterials.vue?vue&type=template&id=affc8e22&scoped=true&"
import script from "./MarketingMaterials.vue?vue&type=script&lang=js&"
export * from "./MarketingMaterials.vue?vue&type=script&lang=js&"
import style0 from "./MarketingMaterials.vue?vue&type=style&index=0&id=affc8e22&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "affc8e22",
  null
  
)

export default component.exports